export default __webpack_public_path__ + "static/media/14.8cb8b456.jpg";